@if (title) {
  <h3 class="heading4">{{ title }}</h3>
}

<mr-details-list split="fifths">
  <mr-details-item title="PO's:">
    @if (orders?.length) {
      @for (order of orders; track order) {
        <div>
          <div class="po-details">
            <div class="po-details__number">{{ order.number }}</div>
            @if (order.dueDate) {
              <div class="po-details__date">due {{ order.dueDate | day }}</div>
            }
          </div>
        </div>
      }
    } @else {
      <span class="text-italic">Not entered</span>
    }
  </mr-details-item>
</mr-details-list>
